import { FormlyFieldConfig } from 'ng-formly';
export const approleFields: Array<FormlyFieldConfig> = [

    {
        key: 'name',
        type: 'input-field',
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: true,
            label: 'Role Name'
        }
    }

];


// WEBPACK FOOTER //
// ./src/app/shared/formfields/approle.ts